<template>
    <div class="module__iframe_scorm">
        <template v-if="scormUrl && scormId">
            <iframe :src="outputScormUrl + '/preview.html?id=' + scormId"></iframe>
        </template>
    </div>
</template>

<script>
export default {
  name: 'module-iframe-scorm',
  computed: {
    scormUrl () {
      return this.$store.getters.getEbsModuleCustomContentData.url
    },
    scormId () {
      return this.$store.getters.getEbsModuleCustomContentData.id
    },
    outputScormUrl () {
      return this.scormUrl ? this.scormUrl.slice(0, this.scormUrl.indexOf('/original')) : undefined
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/modules/moduleiframescorm";
</style>
